import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ParcelService {

  constructor(private _http: HttpClient) { }

  printAllParcelsForOrderOrRoute(orderIdOrRouteId: string, isOrderOnDemand: boolean, postDate: string | null): Observable<Blob> {
    
    if (isOrderOnDemand) {
      return this.printAllParcelsForOrder(orderIdOrRouteId);
    } else {
      return this.printAllParcelsForRoute(orderIdOrRouteId, postDate);
    }
  }

  printAllParcelsForOrder(orderId: string): Observable<Blob> {
    let params: HttpParams = new HttpParams();

    if (environment.siteId !== null) {
      params = params.append('siteId', environment.siteId);
    }
    
    return this._http.get<Blob>(`${environment.apiUrl}/v2/Orders/${orderId}/Parcels/PDF`, { 
      params, 
      responseType: 'blob' as 'json' 
    });
  }

  printAllParcelsForRoute(routeId: string, postDate: string | null): Observable<Blob> {
    let params: HttpParams = new HttpParams();

    if (postDate !== null) {
      params = params.append('postDate', postDate);
    }

    if (environment.siteId !== null) {
      params = params.append('siteId', environment.siteId);
    }
    
    return this._http.get<Blob>(`${environment.apiUrl}/v2/Routes/${routeId}/Parcels/PDF`, { 
      params, 
      responseType: 'blob' as 'json' 
    });
  }

  emailParcelForOrderOrRoute(orderIdOrRouteId: string, email: any, isOrderOnDemand: boolean, postDate: string | null): Observable<Blob> {
    if (isOrderOnDemand) {
      return this.emailParcelForOrder(orderIdOrRouteId, email);
    } else {
      return this.emailParcelForRoute(orderIdOrRouteId, email, postDate);
    }
  }

  emailParcelForOrder(orderId: string, email: any): Observable<Blob> {
    let params: HttpParams = new HttpParams();
    
    if (environment.siteId !== null) {
      params = params.append('siteId', environment.siteId);
    }
    
    return this._http.post<Blob>(`${environment.apiUrl}/v2/Orders/${orderId}/Parcels/Email`, email, { 
      params
    }).pipe(map(res => res));
  }

  emailParcelForRoute(routeId: string, email: any, postDate: string | null): Observable<Blob> {
    let params: HttpParams = new HttpParams();
    
    if (environment.siteId !== null) {
      params = params.append('siteId', environment.siteId);
    }
    
    return this._http.post<Blob>(`${environment.apiUrl}/v2/Routes/${routeId}/${postDate}/Parcels/Email`, email, { 
      params
    }).pipe(map(res => res));
  }
}
